import { CalendarRoot } from "PFApp/booking/types/calendar_root";

export const projectsKeys = {
  all: () => ["projects"],
  withParameters: (calendarRoot: CalendarRoot, filters: any, order: any, page: number, perPage: number) => [
    ...projectsKeys.all(),
    calendarRoot,
    { filters, order },
    page,
    perPage
  ],
  pinned: (calendarRoot: CalendarRoot, filters: any, order: any, page: number, perPage: number) => [
    ...projectsKeys.withParameters(calendarRoot, filters, order, page, perPage),
    "pinned"
  ]
};
